import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {SiteModel} from '../../../../models/SiteModel';
import {SiteAnagrafService} from '../../../general-services/service-site-anagraf/site-anagraf.service';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-edit-site-anagraf',
  templateUrl: './edit-site-anagraf.component.html',
  styleUrls: ['./edit-site-anagraf.component.scss']
})
export class EditSiteAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  site: SiteModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;
  submitted = false;

  id: number;
  siteCod: string;
  description: string;
  siteJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private siteService: SiteAnagrafService, private _activatedRoute: ActivatedRoute,
              private loaderService: LoaderService) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.siteJson = params['row'];
      });

    this.site = new SiteModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });
    this.site = JSON.parse(this.siteJson) as SiteModel;

    this.formValidator.patchValue({
      cod: this.site ? this.site.cod : ''
    });

    this.formValidator.patchValue({
      description: this.site ? this.site.description : ''
    });

    _activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.siteCod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SITE_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.site.cod = this.formValidator.controls['cod'].value;
      this.site.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.siteService.update(this.siteService.baseUrl, this.site).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Site Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Site was edited with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SITE_ANAGRF]);
          }
        }, error => {
          this.loaderService.display(false);
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.formValidator.controls; }

}
